import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const FloatingCartBar = ({ onClick }) => {
  const { getCartItemsCount, getGrandTotal, cartItems, packagingItems } = useCart();
  
  const itemCount = getCartItemsCount();
  const totalPrice = getGrandTotal();
  
  // Don't show if cart is empty
  if (itemCount === 0) return null;
  
  return (
    <div 
      onClick={onClick}
      className="fixed bottom-4 left-4 right-4 z-40 mx-auto max-w-md cursor-pointer animate-slideUp"
    >
      <div className="bg-gradient-to-r from-[#00BCD4] to-[#00ACC1] text-white rounded-2xl shadow-2xl px-6 py-4 flex items-center justify-between hover:shadow-3xl transition-all duration-300 hover:scale-105">
        <div className="flex items-center space-x-3">
          <div className="bg-white/20 p-2 rounded-xl">
            <ShoppingCart className="w-5 h-5" />
          </div>
          <div>
            <p className="font-bold text-sm">Kosár megtekintése</p>
            <p className="text-xs opacity-90">{itemCount} tétel</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-2xl font-black">{totalPrice} Ft</p>
        </div>
      </div>
    </div>
  );
};

export default FloatingCartBar;
